import React, { Fragment } from 'react';
import GroupBg from '../assets/main/bg-group.jpg';
import Header from '../components/Header';
import DeputyGroup from '../components/DeputyGroup';
import { useParams } from 'react-router-dom';
import { getDeputyTitleFromRouteId, getGroupDeputy } from '../utils/deputy';
import { useTranslation } from 'react-i18next';
import { getBackgroundImage } from '../utils/organization';

export default function GroupPage() {
  const { id } = useParams();
  const { t } = useTranslation();

  return (
    <div
      className="min-h-screen bg-darkBlue flex text-white bg-cover bg-no-repeat pt-60 pb-40 pl-60 pr-80"
      style={{
        backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.6) 100%), url(${GroupBg})`,
      }}
    >
      <div className="w-full">
        <Header />
        <div className="mt-[150px] flex space-x-32">
          {getGroupDeputy(id).map((deputy) => (
            <Fragment key={deputy}>
              <DeputyGroup
                text={getDeputyTitleFromRouteId(deputy, t)}
                route={`/${deputy}`}
                background={getBackgroundImage(deputy)}
              />
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
